var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResourcesTemplatesIcon = function SvgResourcesTemplatesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 84,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFEEF7",
    strokeWidth: 20,
    d: "m91.333 41-73-31 73 64-89-21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6255AE",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M65.23 64.377h-35.7a6.7 6.7 0 0 1-6.697-6.697V21.957h17.85l6.65 8.936h24.594V57.68a6.7 6.7 0 0 1-6.697 6.697ZM47.38 21.957h26.787"
  })));
};
export default SvgResourcesTemplatesIcon;